import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiForgotResetpasswordMutationRequest,
  PostApiForgotResetpasswordMutationResponse,
  PostApiForgotResetpassword401,
  PostApiForgotResetpassword403,
} from "../../../types/PostApiForgotResetpassword";

export function getPostApiForgotResetpasswordUrl() {
  return `/api/Forgot/ResetPassword` as const;
}

/**
 * {@link /api/Forgot/ResetPassword}
 */
export async function postApiForgotResetpassword(
  data?: PostApiForgotResetpasswordMutationRequest,
  config: Partial<RequestConfig<PostApiForgotResetpasswordMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiForgotResetpasswordMutationResponse,
    ResponseErrorConfig<
      PostApiForgotResetpassword401 | PostApiForgotResetpassword403
    >,
    PostApiForgotResetpasswordMutationRequest
  >({
    method: "POST",
    url: getPostApiForgotResetpasswordUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
